import { createFileRoute } from '@tanstack/react-router'

import { createEnumGuard } from '#/utils/typeGuards'
import { BUDGET_PERIOD_TYPES, type TBudgetPeriodType } from '#interfaces/budgetPeriodType'
import {
  PERSONAL_CARD_BUDGET_FILTERS,
  PERSONAL_CARD_STATUS_FILTERS,
  type TPersonalCardBudgetFilter,
  type TPersonalCardStatusFilter,
} from '#pages/PersonalCards/interfaces'

interface IOvCardsSearch {
  search?: string
  openEngravedId?: string
  sortBy?: string
  sortDir?: 'asc' | 'desc'
  cardStatus?: TPersonalCardStatusFilter
  budget?: TPersonalCardBudgetFilter
  budgetPeriodType?: TBudgetPeriodType
}

const isCardStatusSearch = createEnumGuard(PERSONAL_CARD_STATUS_FILTERS)
const isBudgetSearch = createEnumGuard(PERSONAL_CARD_BUDGET_FILTERS)
const isBudgetPeriodTypeSearch = createEnumGuard(BUDGET_PERIOD_TYPES)

export const Route = createFileRoute('/_authenticated/ov-cards')({
  validateSearch: (search: Record<string, unknown>): IOvCardsSearch => ({
    search: typeof search.search === 'string' && search.search.length > 0 ? search.search : undefined,
    openEngravedId:
      typeof search.openEngravedId === 'string' && search.openEngravedId.length > 0 ? search.openEngravedId : undefined,
    sortBy: typeof search.sortBy === 'string' && search.sortBy.length > 0 ? search.sortBy : undefined,
    sortDir: search.sortDir === 'asc' || search.sortDir === 'desc' ? search.sortDir : undefined,
    cardStatus:
      typeof search.cardStatus === 'string' && isCardStatusSearch(search.cardStatus) ? search.cardStatus : undefined,
    budget: typeof search.budget === 'string' && isBudgetSearch(search.budget) ? search.budget : undefined,
    budgetPeriodType:
      typeof search.budgetPeriodType === 'string' && isBudgetPeriodTypeSearch(search.budgetPeriodType)
        ? search.budgetPeriodType
        : undefined,
  }),
})
